export const LEGAL_ROUTES = [
  { path: "/about", slug: "about" },
  { path: "/biga-circle", slug: "biga-circle" },
  { path: "/catering", slug: "catering" },
  { path: "/gift-cards", slug: "gift-cards" },
  { path: "/faq", slug: "faq" },
  { path: "/careers", slug: "careers" },
  { path: "/investors", slug: "investors" },
  { path: "/blog", slug: "blog" },
  { path: "/terms", slug: "terms" },
  { path: "/privacy", slug: "privacy" },
  { path: "/vulnerability", slug: "vulnerability" },
];
